export default __webpack_public_path__ + "static/media/compliant.5c8a2542.webp";